import * as Yup from "yup";

export const userValidation = (isEdit = false) => Yup.object().shape({
  mobile: Yup.string()
    .required("وارد کردن موبایل الزامی است")
    .matches(/^09\d{9}$/, "شماره تماس اشتباه است . دقت کنید باید با 09 شروع شود")
    .min(11, "موبایل باید 11 رقمی باشد!")
    .max(11, "موبایل باید 11 رقمی باشد!"),
  password: isEdit 
    ? Yup.string()
        .min(5, "رمز عبور خیلی کوتاه است!")
        .max(48, "رمز عبور خیلی بلند است!")
    : Yup.string()
        .required("وارد کردن رمز عبور الزامی است")
        .min(5, "رمز عبور خیلی کوتاه است!")
        .max(48, "رمز عبور خیلی بلند است!"),
  name: Yup.string()
    .nullable()
    .test('min-length', 'نام باید حد اقل 3 حرفی باشد.', function(value) {
      if (!value || value.length === 0) return true;
      return value.length >= 3;
    }),
  role: Yup.string()
    .required("انتخاب نقش الزامی است"),
  address: Yup.string()
    .nullable()
    .test('min-length', 'آدرس حد اقل باید 10 حرف داشته باشد.', function(value) {
      if (!value || value.length === 0) return true;
      return value.length >= 10;
    }),
});
